var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"host-map position-relative",staticStyle:{"height":"300px","width":"100%"}},[(_vm.hosts && _vm.hosts.length > 0)?_c('MapComponent',{attrs:{"hosts":_vm.hosts,"zoom":10,"shows-host-popup":false,"fits-hosts":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }